export const normalizeMemberCode = (value: string | undefined | null): string => {
	const sanitized = value?.trim() || "";
	// If perfectly numeric, strip leading zeros
	if (/^\d+$/.test(sanitized)) {
		const parsed = parseInt(sanitized, 10);
		return isNaN(parsed) ? sanitized : parsed.toString();
	}
	return sanitized;
};
